export default __webpack_public_path__ + "static/media/TelegramLogo.8b5ba6ea.svg";